export default __webpack_public_path__ + "static/media/RedDieselES.0e2f551c.svg";